const StateBoard = {
    PLAY: 'play',
    PAUSE: 'pause',
    RESIZED: 'resized',
    WON: 'won',
    LOSE: 'lose',
}

export default StateBoard;